// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1X4RS","logo":"Header_logo__ztHSm"};